import type { RouteRecordRaw } from 'vue-router';

export const serviceOrdersRoutes: RouteRecordRaw[] = [
  {
    path: 'service-orders',
    name: 'service-orders',
    component: () => import('./pages/ServiceOrdersListPage.vue'),
    meta: { title: 'Service orders', requiresAuth: true, permission: 'view_service_orders' },
  },
  {
    path: 'service-due',
    name: 'service-due',
    component: () => import('./pages/ServiceDuePage.vue'),
    meta: { title: 'Service due', requiresAuth: true, permission: 'view_service_orders' },
  },
  {
    path: 'service-orders/new',
    name: 'service-orders.create',
    component: () => import('./pages/ServiceOrderFormPage.vue'),
    meta: { title: 'New service order', requiresAuth: true, permission: 'create_service_orders' },
  },
  {
    path: 'service-orders/:id/edit',
    name: 'service-orders.edit',
    component: () => import('./pages/ServiceOrderFormPage.vue'),
    meta: { title: 'Edit service order', requiresAuth: true, permission: 'update_service_orders' },
  },
  {
    path: 'service-orders/:id',
    name: 'service-orders.show',
    component: () => import('./pages/ServiceOrderDetailPage.vue'),
    meta: { title: 'Service order', requiresAuth: true, permission: 'view_service_orders' },
  },
];
